import RelatedEntitiesList from './RelatedEntitiesList';
export default RelatedEntitiesList;
